<template>
  <v-layout row wrap>
    <v-flex xs12 class="telaDadosFrota">
      <div class="header-step">
        <h3>Dados da Frota</h3>
        <p>Vamos conhecer um pouco da composição da frota.</p>
      </div>
      <v-form v-model="validCampos">
        <v-layout row wrap>
          <v-flex md4>
              <v-btn :disabled="disableFrota" color="secondary" @click="dialogAdicionaVeiculo = true">ADICIONAR VEÍCULOS</v-btn>
          </v-flex> 
          <v-flex md12>
            <div class="data-table-frota mb-4">
              <v-data-table
                :headers="headersFrota"
                :items="listFrotaAdicionado"
                class="elevation-0"
                hide-actions
              >
                <template v-slot:no-data >
                  <p></p>
                </template>
                <template v-slot:items="props">
                  <td>
                    {{ props.item.tipoFrota }}
                  </td>
                  <td>
                    {{ props.item.categoriaVeiculos.toString() }}
                  </td>
                  <td>
                    {{ (props.item.tecnologiaRastreamento && props.item.tecnologiaRastreamento.length > 0) ?
                        props.item.tecnologiaRastreamento.toString() :
                        '-'
                    }}
                  </td>
                  <td>
                    {{ props.item.quantidadeVeiculos }}
                  </td>
                  <td>
                    {{ props.item.tecnologiaSatelital ? props.item.tecnologiaSatelital : '-' }}
                  </td>
                  <td>
                    {{ props.item.idadeMedia ? props.item.idadeMedia : '-' }}
                  </td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      small
                      :disabled="disableFrota"
                      class="mr-2"
                      @click="editarItem(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      :disabled="disableFrota"
                      @click="deletarItemFrota(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm5>
            <h4 class="primary--text">Possui outros tipos de equipamento?</h4>
            <v-radio-group :disabled="disableFrota" required v-model="dadosFrota.outrosOpcao" row>
                <v-radio 
                    color="primary" 
                    id="chkNaoPossuiOutrosTipos" 
                    ref="chkNaoPossuiOutrosTipos" 
                    label="Não" 
                    value="false">
                </v-radio>
                <v-radio 
                    color="primary" 
                    id="chkSimOutrosTipos" 
                    ref="chkSimOutrosTipos" 
                    label="Sim" 
                    value="true">
                </v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-flex v-show="dadosFrota.outrosOpcao == 'true'" xs6 sm2>
          <v-text-field 
            label="Especifique" 
            v-model="dadosFrota.outrosTipos"
            placeholder="Isca RF"
            :disabled="disableFrota"
            :rules="regras.tipoFrotaVazio"
          >
          </v-text-field>
        </v-flex>
        <v-layout row>
          <v-flex xs4 md3>
            <v-btn flat @click="$emit('voltarDadosFrota', true)" color="primary">
                Voltar
            </v-btn>
          </v-flex>
          <v-flex xs4 md3>
            <v-btn
              :disabled="validarPassoFrota"
              @click="clickProximoFrota"
              color="primary"
            >
              proximo
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
    <v-dialog persistent v-model="dialogAdicionaVeiculo" max-width="350px">
      <v-card>
        <v-card-title class="title-dialog-custom">
          {{ editedIndex > -1 ? "Editar" : "Adicionar"}} veículos
        </v-card-title>
        <v-card-text>
          <v-form ref="modelFrotaForm" v-model="formAdicionarFrota">
            <v-select
                label="Tipo da frota"
                id="txtDadosFrotaSelectTipo"
                ref="txtSelectTipo"
                v-model="frotaModel.tipoFrota"
                placeholder="Selecione uma opção"
                :items="lstTipo"
                :rules="regras.tipoFrotaVazio"
            >
            </v-select>
            <v-select
              label="Categoria dos veículos"
              id="txtDadosFrotaSelectCategoria"
              ref="txtSelectCategoria"
              v-model="frotaModel.categoriaVeiculos"
              placeholder="Selecione uma opção"
              :items="lstCategorias"
              :rules="regras.categoriaVazio"
              multiple
            >
            </v-select>
            <v-text-field 
              label="Quantidade de veículos" 
              v-model="frotaModel.quantidadeVeiculos"
              type="number"
              min="0"
              :rules="regras.quantidade"
            >
            </v-text-field>
            <v-text-field 
              label="Idade média" 
              v-model="frotaModel.idadeMedia"
              placeholder="Informe a idade média dos veículos"
              type="number"
            >
            </v-text-field>
            <v-select
              label="Tecnologias de rastreamento"
              id="txtDadosFrotaSelectTecnologia"
              ref="txtSelectTecnologia"
              v-model="frotaModel.tecnologiaRastreamento"
              item-text="titulo"
              item-value="titulo"
              placeholder="Selecione uma opção"
              :items="lstTecnologias"
              multiple
            >
            </v-select>
            <v-text-field 
              label="Veículos com tecnologia satelital" 
              v-model="frotaModel.tecnologiaSatelital"
              placeholder="Informe a quantidade de veículos"
              type="number"
            >
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="primary" @click="tratamentoFecharDialogAdicionarFrota">
              Cancelar
          </v-btn>
          <v-btn color="primary" :disabled="!formAdicionarFrota" @click="tratamentoSalvarDialogAdicionarFrota">
              Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado";

export default {
  name: "QARDadosFrota",

  props: {
    protocolo: String,
    dadosQuestionarioCompleto: {
      type: Object, 
      required: false,
    }
  },

  data: () => {
    return {
      dadosFrota: {
        veiculosFrota: {},
        outrosOpcao: "false",
        outrosTipos: null
      },
      dialogAdicionaVeiculo: false, 
      editedIndex: -1,
      validCampos: true,
      formAdicionarFrota: true,
      listFrotaAdicionado: [],
      lstTipo: [
        'Própria',
        'Agregados',
        'Autônomos',
        'Transportadora'
      ],
      lstCategorias: [
        'Fechados',
        'Abertos',
        'Sider',
        'Bi-trem'
      ],
      lstTecnologias: [],
      frotaModel: {
        tipoFrota: null,
        categoriaVeiculos: null,
        quantidadeVeiculos: null,
        idadeMedia: null,
        tecnologiaRastreamento: null,
        tecnologiaSatelital: null
      },

      regras: {
        tipoFrotaVazio: [
          v => !!v || 'Você não pode deixar este campo em branco'
        ],
        categoriaVazio: [
          v => (!!v && v.length > 0) || 'Você não pode deixar este campo em branco',
        ],
        quantidade: [
          v => (!!v && v > 0) || 'Você não pode deixar este campo em branco',
        ]
      },

      headersFrota: [
        { text: "Tipo da frota", width: "50px", value: "tipofrota", align:"center", sortable: false },
        { text: "Categoria dos veículos", value: "categoriaVeiculos", width: "50px", align:"center", sortable: false },
        { text: "Tecnologias de rastreamento", value: "tecnologiarastreamento", width: "50px", align:"center", sortable: false },
        { text: "Quantidade de veículos", value: "quantidadeveiculos", width: "50px", align:"center", sortable: false },
        { text: "Veículos com tec. satelital", value: "satelital", width: "50px", align:"center", sortable: false },
        { text: "Idade média", value: "idademedia", width: "50px", align:"center", sortable: false },
        { text: "Ações", width: "50px", value: "acao", align:"center", sortable: false },
      ]
    }
  },
  computed: {
    disableFrota() {
      return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
    },
    validarPassoFrota() {
      if (this.dadosFrota.outrosOpcao == "true" && !this.dadosFrota.outrosTipos) {
        return true;
      }
      return false;
    }
  },
  watch: {
    dadosQuestionarioCompleto(val) {
      if(val.id != null  &&  val.id != undefined) {
        for(var frota of val.dadosOperacionais.veiculosFrota) {
          this.listFrotaAdicionado.push({
            categoriaVeiculos: frota.categoriaVeiculos,
            idEstadoDestino: frota.idEstadoDestino,
            idadeMedia: frota.idadeMedia,
            quantidadeVeiculos: frota.quantidadeVeiculos,
            tecnologiaRastreamento: frota.tecnologiaRastreamento,
            tecnologiaSatelital: frota.tecnologiaSatelital,
            tipoFrota: frota.tipoFrota
          });
        }
        this.dadosFrota.outrosOpcao = val.dadosOperacionais.outrosOpcao == true ? "true" : "false";
        this.dadosFrota.outrosTipos = val.dadosOperacionais.outrosTipos ? val.dadosOperacionais.outrosTipos : null;
      }
    },
    'dadosFrota.outrosOpcao'() {
      if (this.dadosFrota.outrosOpcao == "false") {
        return this.limpaCampo();
      }
    }
  },
  mounted: function () {
    this.$refs.modelFrotaForm.reset();
    this.buscarTecnologiasRastreamento();
  },
  methods: {
    clickProximoFrota() {
      this.dadosFrota.veiculosFrota = this.listFrotaAdicionado;
      this.$emit('dadosFrota', this.dadosFrota);
    },

    limpaCampo() {
      this.dadosFrota.outrosTipos = null;
    },

    buscarTecnologiasRastreamento() {
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tecnologiaRastreamento`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.lstTecnologias = response.data
      });
    },

    editarItem(item) {

      Array.isArray(item.categoriaVeiculos) ? item.categoriaVeiculos : item.categoriaVeiculos = item.categoriaVeiculos.split(",", 4)
      item.tecnologiaRastreamento == undefined || Array.isArray(item.tecnologiaRastreamento)
        ? item.tecnologiaRastreamento 
        : item.tecnologiaRastreamento = item.tecnologiaRastreamento.split(",", 4)

      this.editedIndex = this.listFrotaAdicionado.indexOf(item)

      this.frotaModel = Object.assign({}, item)
      this.dialogAdicionaVeiculo = true
    
    },

    deletarItemFrota(item) {
      const index = this.listFrotaAdicionado.indexOf(item)
      this.listFrotaAdicionado.splice(index, 1);
    },

    tratamentoSalvarDialogAdicionarFrota() {
      let auxProp = {...this.frotaModel};
      auxProp.categoriaVeiculos = auxProp.categoriaVeiculos.toString()
      auxProp.tecnologiaRastreamento = auxProp.tecnologiaRastreamento ? auxProp.tecnologiaRastreamento.toString() : undefined
      if(this.editedIndex  > -1) {
        Object.assign(this.listFrotaAdicionado[this.editedIndex], auxProp) 
      } else {
        this.listFrotaAdicionado.push(auxProp);
      }
      this.tratamentoFecharDialogAdicionarFrota();
    },
    limparDadosFrota() {
      this.frotaModel.tipoFrota = null;
      this.frotaModel.categoriaVeiculos = null;
      this.editedIndex = -1;
      this.$refs.modelFrotaForm.reset();
      this.$refs.modelFrotaForm.resetValidation();
    },
    tratamentoFecharDialogAdicionarFrota() {
      this.limparDadosFrota();
      this.dialogAdicionaVeiculo = false;
    },
  }
}
</script>

<style>
  .QuestionarioAnaliseRiscos .telaDadosFrota{
    margin-top: 32px;
    margin-left: 15px;
  }
  .QuestionarioAnaliseRiscos .title-dialog-custom {
    color: #00456e;
    font-weight: bold;
    padding-bottom: 0;
    font-size: 18px;
  }
  .telaDadosFrota table.v-table tbody td {
    padding: 0 12px!important;
    text-align: center;
  }
  .telaDadosFrota table.v-table tbody td:nth-child(1) {
    padding: 0!important;
  }
  .telaDadosFrota .container.grid-list-md .layout:not(:only-child) {
    margin: auto 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARDadosFrota.vue